module.exports = __webpack_public_path__ + "static/android-5af4ffad60fa0ebd981c134edfb8fddc.svg";